import React from 'react';
import { IconButton } from '@mui/material';
import { IconRecordSolid, IconStopCircleDuotone } from '@roku-web-ui/rds-icons';
import { colors } from '@roku-web-ui/rds-theme';

import { RecordingContext } from 'context/state/camera';

import { Tooltip } from 'components/common/Tooltip';

import { useAspenLogger } from 'hooks/useAspenLogger';

import { dispatchEvent } from 'modules/globalEvents';

type RecordProps = {
  leafId: string;
  recording: RecordingContext;
};

export const Record = ({ leafId, recording }: RecordProps) => {
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title={recording?.recordingEnabled ? 'Stop recording' : 'Start recording'} placement="top">
      <IconButton
        aria-label="record-video"
        data-testid="button-record-video"
        onClick={() => {
          dispatchEvent({
            leafId,
            event: 'TOGGLE_RECORDING',
            data: { newValue: !recording.recordingEnabled },
          });

          logAspenEvent({
            log_id: 'iot.web.stream.interaction',
            payload: {
              device_id: leafId,
              interaction: 'record',
            },
          });
        }}
        sx={{
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        {recording?.recordingEnabled ? (
          <IconStopCircleDuotone sx={{ color: colors.purple[500] }} />
        ) : (
          <IconRecordSolid sx={{ color: colors.grey[400] }} />
        )}
      </IconButton>
    </Tooltip>
  );
};
